<template>
<div class="contact-section content">
    <label class="label">{{ $t('contactExtensionDev') }}</label>
    <ul>
        <li>
            Post feature requests on my Suggestion Box:
            <a target="_blank" :href="guanzoTwitchLink">twitch.tv/guanzo</a><br>
            This way, popular requests get upvoted and I know what
            to work on.
        </li>
        <li>
            Get live tech support on
            <a :href="discordInviteLink" target="_blank">discord</a>.
        </li>
        <li>
            Use this contact form. I read everything. Your feedback matters. No Kappa.
        </li>
    </ul>
    <FeedbackForm/>
    <p>
        Like the extension? I'm a solo developer who works on this in my spare time.<br>
        Support me and help cover server costs.
        <a href="https://www.buymeacoffee.com/guanzo" target="_blank">
            buymeacoffee.com/guanzo
        </a>
    </p>
    <p>Thanks for using Suggestion Box.</p>
</div>
</template>

<script>
import FeedbackForm from '@/components/FeedbackForm'
import * as C from '@shared/constants'

export default {
    name: 'ContactSection',
    data: () => ({
        discordInviteLink: C.DISCORD_INVITE_LINK,
        guanzoTwitchLink: 'https://www.twitch.tv/guanzo',
    }),
    components: {
        FeedbackForm
    }
}
</script>

<style lang="scss" scoped>
.contact-section {
    font-size: .85rem;
}
</style>
